
// import React, { useEffect, useLayoutEffect, useState } from "react";
// import { Layout, Spin, Modal, Input } from "antd";
// import { useSelector } from "react-redux";
// import axios from "axios";
// import { BaseUrl } from "../shared/BaseUrl";
// import AudioPlayer from "react-h5-audio-player";
// import "react-h5-audio-player/lib/styles.css";
// import ReactPlayer from "react-player";
// import { toast } from "react-toastify";
// import { useLocation } from "react-router-dom";
// import "./currentContent.css";

// const { Content } = Layout;

// export const CurrentContent = () => {
//   const [qrCodeURL, setQRCodeURL] = useState("");
//   const [currentContent, setCurrentContent] = useState("");
//   const [qrId, setQrId] = useState();
//   const token = localStorage.getItem("token");
//   const location = useLocation();
//   const searchParams = new URLSearchParams(location.search);
//   const userId = searchParams.get("un");
//   const [pin, setPin] = useState(null);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [tempPin, setTempPin] = useState("");

//   useLayoutEffect(() => {
//     const fetchQr = async () => {
//       try {
//         const response = await axios.get(`${BaseUrl}/api/qrcode/user/qr`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         if (response.data.data === null) {
//           // Check if data is null
//           // navigate("/content"); // Navigate to the desired route
//         } else {
//           setQRCodeURL(response.data.text);
//           setQrId(response?.data?._id);
//         }
//         console.log(response.data);
//       } catch (error) {
//         if (error.response && error.response.status === 400) {
//           if (error.response.data.data === null) {
//             toast.error("no content found yet please generate one", {
//               position: "top-right",
//               autoClose: 3000,
//               hideProgressBar: false,
//               closeOnClick: true,
//               pauseOnHover: true,
//               draggable: true,
//               progress: undefined,
//             });
//           } else {
//             console.error("Login error:", error.response.data.message);
//           }
//         } else {
//           console.error("Login error:", error.message);
//         }
//       }
//     };
//     fetchQr();
//   }, [token]);

//   const fetchCurrentQr = async (pin) => {
//     try {
//       const endpoint = userId ? `user/${userId}` : `qr/${qrId}`;

//       const headers = { Authorization: `Bearer ${token}` };
//       if (pin) {
//         headers["x-content-pin"] = pin;
//       }

//       const response = await axios.get(
//         `${BaseUrl}/api/content/current-content/${endpoint}`,
//         { headers }
//       );

//       setCurrentContent(response?.data.currentContent);
//     } catch (error) {
//       if (error.response && error.response.data.message === "Invalid PIN provided") {
//         setIsModalVisible(true);
//       } else {
//         console.error("Error fetching current content:", error.message);
//       }
//     }
//   };

//   useEffect(() => {
//     fetchCurrentQr(pin);
//   }, [userId, qrId, token, pin]);

//   const handleOk = () => {
//     setPin(tempPin);
//     setIsModalVisible(false);
//   };

//   const handleCancel = () => {
//     setIsModalVisible(false);
//   };

//   return (
//     <Layout
//       style={{
//         padding: "0 24px 24px",
//         height: "95vh",
//         background: "transparent",
//         alignItems: "center",
//         justifyContent: "center",
//       }}
//     >
//       <div>
//         {currentContent?.contentType === "image" && (
//           <img
//             style={{
//               alignItems: "center",
//               width: "100%",
//               height: "100%",
//               alignContent: "center",
//             }}
//             src={currentContent.contentUrl}
//             alt="current image"
//           />
//         )}
//         {currentContent?.contentType === "audio" && (
//           <AudioPlayer
//             autoPlay
//             src={currentContent.contentUrl}
//             onPlay={(e) => console.log("onPlay")}
//             className="react-player"
//           />
//         )}
//         {currentContent?.contentType === "video" && (
//           <ReactPlayer
//             playing={true}
//             url={currentContent.contentUrl}
//             height={"70vh"}
//             width={"80vw"}
//             controls={true}
//           />
//         )}
//         {currentContent?.contentType === "text" && (
//           <p style={{ color: "rgb(243, 181, 98)" }}>{currentContent?.text}</p>
//         )}
//         {!currentContent && (
//           <Spin
//             tip="Loading..."
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               height: "100vh",
//             }}
//           />
//         )}
//       </div>

//       <Modal
//         title="Enter PIN"
//         visible={isModalVisible}
//         onOk={handleOk}
//         onCancel={handleCancel}
//       >
//         <Input
//           placeholder="Enter PIN"
//           value={tempPin}
//           onChange={(e) => setTempPin(e.target.value)}
//         />
//       </Modal>
//     </Layout>
//   );
// };


import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { Layout, Spin, Modal, Input, Button } from "antd";
import axios from "axios";
import { BaseUrl } from "../shared/BaseUrl";
import AudioPlayer from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { getQrTagFromLocation } from "../shared/qrLinks";
import "./currentContent.css";

export const CurrentContent = () => {
  const [currentContent, setCurrentContent] = useState(null);
  const [qrId, setQrId] = useState("");
  const token = localStorage.getItem("token");
  const location = useLocation();
  const userId = getQrTagFromLocation(location);
  const [pin, setPin] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [tempPin, setTempPin] = useState("");
  const [isContentLoading, setIsContentLoading] = useState(true);
  const [isImageLoading, setIsImageLoading] = useState(false);
  const [isVideoLoading, setIsVideoLoading] = useState(false);
  const [hasImageError, setHasImageError] = useState(false);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [geoCoords, setGeoCoords] = useState({ latitude: null, longitude: null });
  const imageWrapperRef = useRef(null);

  const getOrCreateVisitorId = () => {
    if (typeof window === "undefined") {
      return "";
    }
    try {
      const existing = localStorage.getItem("tq2_visitor_id");
      if (existing) {
        return existing;
      }
      const generated = `visitor_${Date.now()}_${Math.random()
        .toString(36)
        .slice(2, 12)}`;
      localStorage.setItem("tq2_visitor_id", generated);
      return generated;
    } catch (error) {
      return "";
    }
  };

  useLayoutEffect(() => {
    if (userId) {
      return;
    }
    const fetchQr = async () => {
      try {
        const response = await axios.get(`${BaseUrl}/api/qrcode/user/qr`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (response.data.data !== null) {
          setQrId(response?.data?._id || "");
        } else {
          setQrId("");
          setIsContentLoading(false);
        }
      } catch (error) {
        setIsContentLoading(false);
        if (error.response && error.response.status === 400) {
          if (error.response.data.data === null) {
            toast.error("no content found yet please generate one", {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          } else {
            console.error("Login error:", error.response.data.message);
          }
        } else {
          console.error("Login error:", error.message);
        }
      }
    };
    fetchQr();
  }, [token, userId]);

  useEffect(() => {
    if (!userId || typeof window === "undefined") {
      return;
    }
    if (!navigator?.geolocation || !navigator?.permissions) {
      return;
    }

    let cancelled = false;
    navigator.permissions
      .query({ name: "geolocation" })
      .then((permissionStatus) => {
        if (cancelled || permissionStatus.state !== "granted") {
          return;
        }
        navigator.geolocation.getCurrentPosition(
          (position) => {
            if (cancelled) {
              return;
            }
            setGeoCoords({
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            });
          },
          () => {
            // Optional enhancement only; ignore if unavailable.
          },
          { maximumAge: 300000, timeout: 5000 }
        );
      })
      .catch(() => {
        // Ignore permission API errors.
      });

    return () => {
      cancelled = true;
    };
  }, [userId]);

  const fetchCurrentQr = useCallback(
    async (pinValue) => {
      const endpoint = userId ? `user/${userId}` : qrId ? `qr/${qrId}` : "";
      if (!endpoint) {
        setIsContentLoading(false);
        return;
      }

      setIsContentLoading(true);

      try {
        const headers = {};
        if (!userId && token && token !== "null" && token !== "undefined") {
          headers.Authorization = `Bearer ${token}`;
        }
        if (pinValue) {
          headers["x-content-pin"] = pinValue;
        }
        if (userId) {
          const visitorId = getOrCreateVisitorId();
          if (visitorId) {
            headers["x-visitor-id"] = visitorId;
          }
          if (typeof Intl !== "undefined") {
            headers["x-client-timezone"] =
              Intl.DateTimeFormat().resolvedOptions().timeZone || "";
          }
          if (typeof navigator !== "undefined") {
            headers["x-client-locale"] = navigator.language || "";
            headers["x-client-platform"] = navigator.platform || "";
          }
          if (
            typeof geoCoords.latitude === "number" &&
            typeof geoCoords.longitude === "number"
          ) {
            headers["x-client-lat"] = String(geoCoords.latitude);
            headers["x-client-lng"] = String(geoCoords.longitude);
          }
        }

        const response = await axios.get(
          `${BaseUrl}/api/content/current-content/${endpoint}`,
          { headers }
        );

        setCurrentContent(response?.data?.currentContent || null);
      } catch (error) {
        if (error.response && error.response.data.message === "Invalid PIN provided") {
          setCurrentContent(null);
          setIsModalVisible(true);
        } else {
          setCurrentContent(null);
          console.error("Error fetching current content:", error.message);
        }
      } finally {
        setIsContentLoading(false);
      }
    },
    [geoCoords.latitude, geoCoords.longitude, qrId, token, userId]
  );

  useEffect(() => {
    if (!userId && !qrId) {
      return;
    }
    fetchCurrentQr(pin);
  }, [fetchCurrentQr, pin, qrId, userId]);

  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(Boolean(document.fullscreenElement));
    };
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    if (currentContent?.contentType === "image" && currentContent?.contentUrl) {
      setHasImageError(false);
      setIsImageLoading(true);
    } else {
      setIsImageLoading(false);
      setHasImageError(false);
    }

    if (currentContent?.contentType === "video" && currentContent?.contentUrl) {
      setIsVideoLoading(true);
    } else {
      setIsVideoLoading(false);
    }
  }, [currentContent?.contentType, currentContent?.contentUrl]);

  const handleImageFullscreen = () => {
    const wrapper = imageWrapperRef.current;
    if (!wrapper) {
      window.open(currentContent.contentUrl, "_blank", "noopener,noreferrer");
      return;
    }

    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (wrapper.requestFullscreen) {
      wrapper.requestFullscreen();
    } else {
      window.open(currentContent.contentUrl, "_blank", "noopener,noreferrer");
    }
  };

  const handleOk = () => {
    setPin(tempPin);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  // Custom footer for the Modal
  const modalFooter = (
    <div style={{ display: "flex", justifyContent: "flex-end" }}>
      <Button key="cancel" onClick={handleCancel}>
        Cancel
      </Button>
      <Button
        key="ok"
        type="primary"
        onClick={handleOk}
        style={{ marginLeft: "8px" }}
      >
        OK
      </Button>
    </div>
  );

  return (
    <Layout
      className={`current-content-layout ${userId ? "public-view" : ""}`}
    >
      <div>
        {isContentLoading ? (
          <div className="current-content-loading-block">
            <Spin tip="Loading..." />
          </div>
        ) : null}

        {!isContentLoading && currentContent?.contentType === "image" && (
          <div className="current-content-media-wrapper current-content-image-wrapper" ref={imageWrapperRef}>
            {isImageLoading && (
              <div className="current-content-spinner">
                <Spin tip="Loading..." />
              </div>
            )}
            <button
              className="current-content-fullscreen-btn"
              type="button"
              onClick={handleImageFullscreen}
              aria-label={isFullscreen ? "Exit fullscreen" : "View fullscreen"}
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d="M7 14H5v5h5v-2H7v-3zm0-4h2V7h3V5H5v5zm10 7h-3v2h5v-5h-2v3zm0-12V5h-5v2h3v3h2z" />
              </svg>
            </button>
            <img
              className={`current-content-image ${isImageLoading ? "is-loading" : ""}`}
              src={currentContent.contentUrl}
              alt="current content"
              loading="eager"
              fetchPriority="high"
              decoding="async"
              onLoad={() => setIsImageLoading(false)}
              onError={() => {
                setHasImageError(true);
                setIsImageLoading(false);
              }}
            />
            {hasImageError && (
              <div className="current-content-error">
                Unable to load the current image.
              </div>
            )}
          </div>
        )}

        {!isContentLoading && currentContent?.contentType === "audio" && (
          <AudioPlayer
            autoPlay
            src={currentContent.contentUrl}
            className="react-player"
          />
        )}

        {!isContentLoading && currentContent?.contentType === "video" && (
          <div className="current-content-media-wrapper current-content-video-wrapper">
            {isVideoLoading && (
              <div className="current-content-spinner">
                <Spin tip="Loading video..." />
              </div>
            )}
            <video
              className="current-content-video"
              src={currentContent.contentUrl}
              controls
              autoPlay
              playsInline
              preload="auto"
              onCanPlay={() => setIsVideoLoading(false)}
              onLoadedData={() => setIsVideoLoading(false)}
              onError={() => setIsVideoLoading(false)}
            >
              <source src={currentContent.contentUrl} />
              Your browser does not support the video tag.
            </video>
          </div>
        )}

        {!isContentLoading && currentContent?.contentType === "text" && (
          <div className="current-content-text">{currentContent?.text}</div>
        )}

        {!isContentLoading && !currentContent && (
          <div className="current-content-empty">
            No content is currently assigned to this QR.
          </div>
        )}

        {!isContentLoading &&
          currentContent &&
          !["image", "audio", "video", "text"].includes(currentContent.contentType) && (
            <div className="current-content-empty">
              This content type is not supported for inline preview.
            </div>
          )}
      </div>

      <Modal
        title="Enter PIN"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={modalFooter} // Use custom footer
      >
        <Input
          placeholder="Enter PIN"
          value={tempPin}
          onChange={(e) => setTempPin(e.target.value)}
        />
      </Modal>
    </Layout>
  );
};
